<template>
  <div class="col-lg-12">
    <ejs-treeview ref='measureTreeForDataQueryForSingleReport' :fields='fieldsOfMeasureTreeForSingleReport' :showCheckBox='true' :nodeChecked="measureTreeNodeCheckedForSingleReport" :nodeSelected="measureTreeNodeSelectedForSingleReport"></ejs-treeview>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'NoRealTaskMeasureTreeForSingleReport',
  data() {
    return {
      fieldsOfMeasureTreeForSingleReport: {
        dataSource: [],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      nodeCheckIdListForSingleReport:[],
      nodeCheckInfoListForSingleReport: {}

    }
  },
  methods: {

    measureTreeNodeSelectedForSingleReport(args){
      let checkedNode = [args.node]
      if(args.nodeData.isChecked == "false") {
        this.$refs.measureTreeForDataQueryForSingleReport.checkAll(checkedNode);
      } else {
        this.$refs.measureTreeForDataQueryForSingleReport.uncheckAll(checkedNode);
      }
    },

    measureTreeNodeCheckedForSingleReport(args) {

      // 获取点击的节点信息

      let checkedNodeInfoList = args.data.filter(function (checkedNode) {
        return checkedNode.hasChildren == false;
      }).map(function (checkedNode) {
        return checkedNode;
      });

      let checkedNodeIds = checkedNodeInfoList.map(function(checkedNode){
        return checkedNode.id;
      })


      // 获取点击状态 check/uncheck
      const checkStatus = args.action;

      // 如果状态为点击，将点击的节点添加到点击节点列表中
      if(checkStatus == "check"){
        for(let checkedNode of checkedNodeInfoList){
          this.nodeCheckIdListForSingleReport.push(checkedNode.id);
          this.nodeCheckInfoListForSingleReport[checkedNode.id] = checkedNode;
        }
      // 如果状态为取消点击，从点击节点列表中删除对应元素
      }else if(checkStatus == 'uncheck' ){
        this.nodeCheckIdListForSingleReport = this.nodeCheckIdListForSingleReport.filter(function(nodeCheckedId){
          return checkedNodeIds.indexOf(nodeCheckedId) == -1;
        });
        for(let checkedNodeId of checkedNodeIds){
          delete this.nodeCheckInfoListForSingleReport[checkedNodeId];
        }
      }
    },
    getMeasureTreeForSingleReport(neTypeCode,measureObjCode){
      const params = {
        neTypeCode,
        measureObjCode
      }
      this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskCounterTreeForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fieldsOfMeasureTreeForSingleReport = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>
